import { render, staticRenderFns } from "./add-company.vue?vue&type=template&id=329bfa3c"
import script from "./add-company.vue?vue&type=script&lang=js"
export * from "./add-company.vue?vue&type=script&lang=js"
import style0 from "./add-company.vue?vue&type=style&index=0&id=329bfa3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports